import { useEffect, useMemo, useRef, useState } from "react";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { useNewsFeatures } from "@/hooks/useNewsFeatures";

function isExternalUrl(url: string) {
  return /^https?:\/\//i.test(url);
}

function getNewsFeaturePageSize() {
  if (typeof window === "undefined") return 3;
  if (window.innerWidth >= 992) return 3;
  if (window.innerWidth >= 768) return 2;
  return 1;
}

function EyebrowIcon() {
  return (
    <svg width="100%" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        opacity="0.2"
        d="M14.1981 11.1472L10.3246 12.5746L8.89724 16.4481C8.85782 16.5549 8.78661 16.6471 8.6932 16.7122C8.59979 16.7772 8.48867 16.8121 8.37482 16.8121C8.26097 16.8121 8.14986 16.7772 8.05645 16.7122C7.96304 16.6471 7.89182 16.5549 7.8524 16.4481L6.42506 12.5746L2.55154 11.1472C2.44473 11.1078 2.35258 11.0366 2.28749 10.9432C2.2224 10.8498 2.1875 10.7387 2.1875 10.6248C2.1875 10.511 2.2224 10.3999 2.28749 10.3064C2.35258 10.213 2.44473 10.1418 2.55154 10.1024L6.42506 8.67506L7.8524 4.80154C7.89182 4.69473 7.96304 4.60258 8.05645 4.53749C8.14986 4.4724 8.26097 4.4375 8.37482 4.4375C8.48867 4.4375 8.59979 4.4724 8.6932 4.53749C8.78661 4.60258 8.85782 4.69473 8.89724 4.80154L10.3246 8.67506L14.1981 10.1024C14.3049 10.1418 14.3971 10.213 14.4622 10.3064C14.5272 10.3999 14.5621 10.511 14.5621 10.6248C14.5621 10.7387 14.5272 10.8498 14.4622 10.9432C14.3971 11.0366 14.3049 11.1078 14.1981 11.1472Z"
        fill="currentColor"
      />
      <path
        d="M14.3952 9.57453L10.7685 8.23437L9.43255 4.60484C9.35343 4.38992 9.2103 4.20443 9.02245 4.07341C8.83461 3.94239 8.6111 3.87214 8.38208 3.87214C8.15305 3.87214 7.92954 3.94239 7.7417 4.07341C7.55386 4.20443 7.41072 4.38992 7.33161 4.60484L5.98723 8.23437L2.3577 9.57031C2.14278 9.64942 1.95729 9.79256 1.82627 9.9804C1.69525 10.1682 1.625 10.3918 1.625 10.6208C1.625 10.8498 1.69525 11.0733 1.82627 11.2612C1.95729 11.449 2.14278 11.5921 2.3577 11.6712L5.98723 13.0156L7.32317 16.6452C7.40228 16.8601 7.54542 17.0456 7.73326 17.1766C7.9211 17.3076 8.14462 17.3779 8.37364 17.3779C8.60266 17.3779 8.82617 17.3076 9.01402 17.1766C9.20186 17.0456 9.34499 16.8601 9.42411 16.6452L10.7685 13.0156L14.398 11.6797C14.6129 11.6006 14.7984 11.4574 14.9294 11.2696C15.0605 11.0818 15.1307 10.8582 15.1307 10.6292C15.1307 10.4002 15.0605 10.1767 14.9294 9.98884C14.7984 9.801 14.6129 9.65786 14.398 9.57875L14.3952 9.57453ZM10.1357 12.0467C10.0593 12.0749 9.98998 12.1192 9.93244 12.1768C9.8749 12.2343 9.83053 12.3036 9.80239 12.38L8.37786 16.2395L6.95614 12.3828C6.92804 12.3057 6.8834 12.2356 6.82534 12.1775C6.76727 12.1195 6.6972 12.0748 6.62005 12.0467L2.76341 10.625L6.62005 9.20328C6.6972 9.17519 6.76727 9.13054 6.82534 9.07248C6.8834 9.01441 6.92804 8.94434 6.95614 8.86719L8.37786 5.01055L9.79958 8.86719C9.82772 8.94354 9.87209 9.01288 9.92963 9.07042C9.98717 9.12796 10.0565 9.17233 10.1329 9.20047L13.9923 10.625L10.1357 12.0467ZM10.6279 3.3125C10.6279 3.16332 10.6871 3.02024 10.7926 2.91475C10.8981 2.80926 11.0412 2.75 11.1904 2.75H12.3154V1.625C12.3154 1.47582 12.3746 1.33274 12.4801 1.22725C12.5856 1.12176 12.7287 1.0625 12.8779 1.0625C13.027 1.0625 13.1701 1.12176 13.2756 1.22725C13.3811 1.33274 13.4404 1.47582 13.4404 1.625V2.75H14.5654C14.7145 2.75 14.8576 2.80926 14.9631 2.91475C15.0686 3.02024 15.1279 3.16332 15.1279 3.3125C15.1279 3.46168 15.0686 3.60476 14.9631 3.71025C14.8576 3.81574 14.7145 3.875 14.5654 3.875H13.4404V5C13.4404 5.14918 13.3811 5.29226 13.2756 5.39775C13.1701 5.50324 13.027 5.5625 12.8779 5.5625C12.7287 5.5625 12.5856 5.50324 12.4801 5.39775C12.3746 5.29226 12.3154 5.14918 12.3154 5V3.875H11.1904C11.0412 3.875 10.8981 3.81574 10.7926 3.71025C10.6871 3.60476 10.6279 3.46168 10.6279 3.3125ZM17.9404 6.6875C17.9404 6.83668 17.8811 6.97976 17.7756 7.08525C17.6701 7.19074 17.527 7.25 17.3779 7.25H16.8154V7.8125C16.8154 7.96168 16.7561 8.10476 16.6506 8.21025C16.5451 8.31574 16.402 8.375 16.2529 8.375C16.1037 8.375 15.9606 8.31574 15.8551 8.21025C15.7496 8.10476 15.6904 7.96168 15.6904 7.8125V7.25H15.1279C14.9787 7.25 14.8356 7.19074 14.7301 7.08525C14.6246 6.97976 14.5654 6.83668 14.5654 6.6875C14.5654 6.53832 14.6246 6.39524 14.7301 6.28975C14.8356 6.18426 14.9787 6.125 15.1279 6.125H15.6904V5.5625C15.6904 5.41332 15.7496 5.27024 15.8551 5.16475C15.9606 5.05926 16.1037 5 16.2529 5C16.402 5 16.5451 5.05926 16.6506 5.16475C16.7561 5.27024 16.8154 5.5625 16.8154 5.5625V6.125H17.3779C17.527 6.125 17.6701 6.18426 17.7756 6.28975C17.8811 6.39524 17.9404 6.53832 17.9404 6.6875Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function NewsFeaturesSection() {
  const { data: items, loading } = useNewsFeatures();
  const newsItems = items ?? [];
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const [pageSize, setPageSize] = useState(getNewsFeaturePageSize);
  const [activePage, setActivePage] = useState(0);

  const pages = useMemo(() => {
    const grouped = [];
    const effectivePageSize = newsItems.length > 3 ? pageSize : 3;
    for (let index = 0; index < newsItems.length; index += effectivePageSize) {
      grouped.push(newsItems.slice(index, index + effectivePageSize));
    }
    return grouped;
  }, [newsItems, pageSize]);

  const hasCarousel = newsItems.length > 3 && pages.length > 1;

  useEffect(() => {
    const handleResize = () => setPageSize(getNewsFeaturePageSize());
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setActivePage(0);
    carouselRef.current?.scrollTo({ left: 0 });
  }, [pageSize, newsItems.length]);

  const scrollToPage = (pageIndex: number) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const nextPage = Math.max(0, Math.min(pageIndex, pages.length - 1));
    carousel.scrollTo({ left: carousel.clientWidth * nextPage, behavior: "smooth" });
    setActivePage(nextPage);
  };

  const handleCarouselScroll = () => {
    const carousel = carouselRef.current;
    if (!carousel || carousel.clientWidth === 0) return;
    const nextPage = Math.round(carousel.scrollLeft / carousel.clientWidth);
    setActivePage(Math.max(0, Math.min(nextPage, pages.length - 1)));
  };

  return (
    <section className="relative pt-28 pb-16 max-[991px]:pt-24 max-[767px]:pt-20 max-[767px]:pb-12">
      <div className="px-[var(--site-margin)]">
        <div className="mx-auto w-full max-w-[80rem]">
          <div>
            <div className="relative z-[2] text-center">
              <div
                data-wf--eyebrow--variant="yellow"
                className="mx-auto flex w-fit justify-start rounded-full border-[0.09rem] border-[rgb(118_42_92_/_10%)] bg-[color-mix(in_srgb,#ffffff_40%,transparent)] p-[0.38rem] font-semibold text-yellow-brand"
              >
                <div className="flex items-center gap-1 rounded-[inherit] border-[inherit] bg-white px-[0.88rem] py-2">
                  <div className="flex w-5 flex-col">
                    <EyebrowIcon />
                  </div>
                  <div className="m-0 text-[0.88rem] font-semibold leading-none text-inherit">Spotlight</div>
                </div>
              </div>

              <div className="mx-auto mt-6 max-w-[70rem] text-left max-[767px]:mt-5">
                <h2 className="mb-8 text-center font-display text-[clamp(2rem,1.5714rem+2.1429vw,3.5rem)] font-medium leading-[1.15] text-[#1f0a18] max-[767px]:mb-6">
                  News & <span className="text-[var(--text-color-alternate)]">Features</span>
                </h2>

                <div className="rounded-[2rem] border border-[#f2a435]/25 bg-[#f2a435]/10 p-5 max-[767px]:rounded-[1.5rem] max-[767px]:p-4 max-[479px]:rounded-[1.25rem] max-[479px]:p-3">
                  {loading ? (
                    <div className="grid grid-cols-3 gap-5 max-[991px]:grid-cols-2 max-[767px]:grid-cols-1">
                      {[0, 1, 2].map((index) => (
                        <div key={index} className="h-80 animate-pulse rounded-[1.5rem] bg-white/85 max-[479px]:rounded-[1.25rem]" />
                      ))}
                    </div>
                  ) : newsItems.length > 0 ? (
                    <>
                      <div className="relative">
                        {hasCarousel && (
                          <>
                            <button
                              type="button"
                              onClick={() => scrollToPage(activePage - 1)}
                              disabled={activePage === 0}
                              className="absolute left-[-3rem] top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-[#f2a435]/30 bg-white text-[#762a5c] shadow-[0_10px_30px_rgba(74,25,60,0.12)] transition hover:-translate-y-[55%] disabled:pointer-events-none disabled:opacity-40 max-[1199px]:hidden"
                              aria-label="Previous News & Features page"
                            >
                              <ChevronLeft className="h-5 w-5" />
                            </button>
                            <button
                              type="button"
                              onClick={() => scrollToPage(activePage + 1)}
                              disabled={activePage === pages.length - 1}
                              className="absolute right-[-3rem] top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-[#f2a435]/30 bg-white text-[#762a5c] shadow-[0_10px_30px_rgba(74,25,60,0.12)] transition hover:-translate-y-[55%] disabled:pointer-events-none disabled:opacity-40 max-[1199px]:hidden"
                              aria-label="Next News & Features page"
                            >
                              <ChevronRight className="h-5 w-5" />
                            </button>
                          </>
                        )}

                        <div
                          ref={carouselRef}
                          onScroll={handleCarouselScroll}
                          className="flex snap-x snap-mandatory overflow-x-auto scroll-smooth rounded-[1.5rem] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden max-[479px]:rounded-[1.15rem]"
                        >
                          {pages.map((page, pageIndex) => (
                            <div key={pageIndex} className="w-full shrink-0 snap-start">
                              <div className="grid grid-cols-3 gap-5 max-[991px]:grid-cols-2 max-[767px]:grid-cols-1">
                                {page.map((item) => {
                                  const external = isExternalUrl(item.link_url);
                                  return (
                                    <a
                                      key={item.id}
                                      href={item.link_url}
                                      target={external ? "_blank" : undefined}
                                      rel={external ? "noopener noreferrer" : undefined}
                                      className="flex h-full flex-col overflow-hidden rounded-[1.5rem] bg-white text-left max-[479px]:rounded-[1.25rem]"
                                    >
                                      <div className="aspect-[16/10] overflow-hidden bg-[#ece7ea]">
                                        <img
                                          src={item.thumbnail_url}
                                          alt=""
                                          className="h-full w-full object-cover"
                                          loading="lazy"
                                        />
                                      </div>
                                      <div className="flex flex-1 flex-col p-5">
                                        <h3 className="m-0 font-display text-[clamp(1.25rem,1.0357rem+1.0714vw,2rem)] font-semibold leading-[1.2] text-pink-darker">
                                          {item.title}
                                        </h3>
                                        {item.description && (
                                          <p className="mt-3 line-clamp-3 text-sm font-medium leading-6 text-[#4a4a4a]">
                                            {item.description}
                                          </p>
                                        )}
                                        <span className="mt-auto inline-flex items-center gap-2 pt-5 text-sm font-bold text-pink-dark">
                                          {item.link_label || "Read more"}
                                          <ArrowUpRight className="h-4 w-4" />
                                        </span>
                                      </div>
                                    </a>
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {hasCarousel && (
                        <div className="mt-5 flex items-center justify-center gap-2" aria-label="News & Features pagination">
                          {pages.map((_, pageIndex) => (
                            <button
                              key={pageIndex}
                              type="button"
                              onClick={() => scrollToPage(pageIndex)}
                              className={`h-2.5 rounded-full transition-all ${activePage === pageIndex ? "w-8 bg-[#762a5c]" : "w-2.5 bg-[#762a5c]/25 hover:bg-[#762a5c]/45"}`}
                              aria-label={`Show News & Features page ${pageIndex + 1}`}
                              aria-current={activePage === pageIndex ? "true" : undefined}
                            />
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="rounded-[1.5rem] bg-white px-6 py-10 text-center font-medium text-[#4a4a4a]">
                      News, press features and announcements are coming soon.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
